import { IOrderClause } from '@tableau/data-catalog-client-components';

import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionDefinition,OptionsDictionary } from './SortOptionDefinitions';

export const sharedWithMeDefaultSortOrder: IOrderClause[] = [Order.desc(OrderKeys.sharedAt)];

// Similar to mixedContentOwner (CommonSortOptions.ts)
export const sharedBySortOptionDefinition: OptionDefinition = {
  id: 'sharedBy',
  getMenuItemDisplayValue: Messages.sharedBy,
  subSortOptions: {
    'asc': {
      id: 'sharedBy.asc',
      field: OrderKeys.sharedBy,
      getMenuItemDisplayValue: Messages.sortByAZ,
      getButtonDisplayValue: Messages.sortBySharedByAsc,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.sharedBy)]
    },
    'desc': {
      id: 'sharedBy.desc',
      field: OrderKeys.sharedBy,
      getMenuItemDisplayValue: Messages.sortByZA,
      getButtonDisplayValue: Messages.sortBySharedByDesc,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.sharedBy)]
    }
  }
};

export const sharedAtSortOptionDefinition: OptionDefinition = {
  id: 'sharedAt',
  getMenuItemDisplayValue: Messages.sharedAt,
  subSortOptions: {
    'desc': {
      id: 'sharedAt.desc',
      field: OrderKeys.sharedAt,
      getMenuItemDisplayValue: Messages.sortByNewest,
      getButtonDisplayValue: Messages.sortBySharedAtNewest,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.sharedAt)]
    },
    'asc': {
      id: 'sharedAt.asc',
      field: OrderKeys.sharedAt,
      getMenuItemDisplayValue: Messages.sortByOldest,
      getButtonDisplayValue: Messages.sortBySharedAtOldest,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.sharedAt)]
    }
  }
};

export const sharedWithMeSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'type': SortOptions.type,
  'sharedBy': sharedBySortOptionDefinition,
  'sharedAt': sharedAtSortOptionDefinition,
  'owner': SortOptions.mixedContentOwner,
};
